import { render, staticRenderFns } from "./merchantBindReview.vue?vue&type=template&id=401b02a1&"
import script from "./merchantBindReview.vue?vue&type=script&lang=js&"
export * from "./merchantBindReview.vue?vue&type=script&lang=js&"
import style0 from "./merchantBindReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports